import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("ms_token");
        if (!token) {
            setLoading(false);
            return;
        }
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => {
                localStorage.removeItem("ms_token");
                setUser(null);
            })
            .finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        // If 2FA is enabled, server returns { requires_2fa: true, pending_token, email }
        if (data.requires_2fa) {
            return { requires_2fa: true, pending_token: data.pending_token, email: data.email };
        }
        localStorage.setItem("ms_token", data.access_token);
        setUser(data.user);
        return data.user;
    };

    const verify2FA = async (pending_token, code) => {
        const { data } = await api.post("/auth/2fa/verify", { pending_token, code });
        localStorage.setItem("ms_token", data.access_token);
        setUser(data.user);
        return data.user;
    };

    const register = async (full_name, email, password) => {
        const { data } = await api.post("/auth/register", { full_name, email, password });
        localStorage.setItem("ms_token", data.access_token);
        setUser(data.user);
        return data.user;
    };

    const logout = () => {
        localStorage.removeItem("ms_token");
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, verify2FA, register, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
